import api from './api'

// const resource = '/auth'
api.defaults.headers.common['x-access-token'] = localStorage.getItem('accessToken');

export default {
    login(params) {
        return api.post(`/auth/login`, params);
    },
    get() {
        return api.get(`/profile`);
    },
    profile(data) {
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        return api.post(`/profile/update`, data, config);
    },
    password(params) {
        return api.put(`/profile/password`, params);
    },
    getUsers(page, q) {
        return api.get(`/users?page=${page}&q=${q}`);
    },
    updateUser(id, params) {
        return api.put(`/users/${id}`, params);
    },
    createUser(params) {
        return api.post(`/users`, params);
    },
    deleteUser(id) {
        return api.delete(`/users/${id}`);
    },
    getUser(npp) {
        return api.get(`/users/${npp}`);
    }
}